import { render, staticRenderFns } from "./dietitian-rank.vue?vue&type=template&id=a2fabb40&scoped=true&"
import script from "./dietitian-rank.vue?vue&type=script&lang=js&"
export * from "./dietitian-rank.vue?vue&type=script&lang=js&"
import style0 from "./dietitian-rank.vue?vue&type=style&index=0&id=a2fabb40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fabb40",
  null
  
)

export default component.exports